import { IconProps } from '@common/types/common';
import { InvertedRadio, InvertedRadioChecked } from '@components/utility/radios/InvertedRadio';
import { Card, CardActionArea, CardContent, Radio } from '@mui/material';
import { PropsWithChildren } from 'react';

type RadioCardProps = {
    checked: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    IconElement?: React.ElementType<IconProps>;
};

const RadioCard = ({ checked, onClick, IconElement, children }: PropsWithChildren<RadioCardProps>) => {
    return (
        <Card elevation={0}>
            <CardActionArea
                onClick={onClick}
                data-active={checked ? '' : undefined}
                className="rounded-md"
                sx={{
                    border: '1px solid #D6D6D6',
                    backgroundColor: (theme) => theme.palette.background.paper,
                    '&:hover': {
                        backgroundColor: '#F7FBFF',
                    },
                    '&[data-active]': {
                        backgroundColor: '#F7FBFF',
                        border: (theme) => `1px solid ${theme.palette.primary.main}`,
                    },
                }}
            >
                <CardContent className="flex flex-col sm:flex-row items-center gap-3 p-[23px_23px_23px_16px]">
                    {IconElement ? (
                        checked ? (
                            <div className="bg-[#B0D5FF] rounded-md p-[10px]">
                                <IconElement />
                            </div>
                        ) : (
                            <div className="bg-[#F3F4F6] rounded-md p-[10px]">
                                <IconElement fill="#707579" stroke="#707579" />
                            </div>
                        )
                    ) : null}
                    {children}
                    <Radio
                        checked={checked}
                        icon={<InvertedRadio />}
                        checkedIcon={<InvertedRadioChecked />}
                        onClick={onClick}
                        className="sm:ml-auto"
                    />
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export { RadioCard };
